module.exports = __webpack_public_path__ + "static/media/Port Identification for their opened services.9230f428.png";